/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */
import * as References from './ApprovalsConfigurationRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovalConfiguration
 */
export const GET_APPROVAL_CONFIGURATION_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovalConfiguration';
export const GET_APPROVAL_CONFIGURATION_QUERY: RegisteredQuery<
  'result',
  References.GetApprovalConfigurationRequestType,
  References.GetApprovalConfigurationResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVAL_CONFIGURATION_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.GetApprovalConfigurationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovalConfigurationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovalConfigurationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovers
 */
export const GET_APPROVERS_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovers';
export const GET_APPROVERS_QUERY: RegisteredQuery<
  'result',
  References.GetApproversRequestType,
  References.GetApproversResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVERS_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.GetApproversRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApproversResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getApproversRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalConfiguration
 */
export const PUT_APPROVAL_CONFIGURATION_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalConfiguration';
export const PUT_APPROVAL_CONFIGURATION_MUTATION: RegisteredQuery<
  'result',
  References.PutApprovalConfigurationRequestType,
  References.PutApprovalConfigurationResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_APPROVAL_CONFIGURATION_MUTATION_FIELD_NAME,
  args: [
    'enabled',
    'approvalTypeId',
    'approvalAction',
    'skipApprovalOption',
    'usersIdsListThatCanSkipApproval',
  ],
  fetcher(
    request: References.PutApprovalConfigurationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutApprovalConfigurationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putApprovalConfigurationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#sendRequestToEnableApprovals
 */
export const SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_sendRequestToEnableApprovals';
export const SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION: RegisteredQuery<
  'result',
  References.SendRequestToEnableApprovalsRequestType,
  References.SendRequestToEnableApprovalsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION_FIELD_NAME,
  args: ['adminToNotifyUserId', 'message', 'approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.SendRequestToEnableApprovalsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SendRequestToEnableApprovalsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.sendRequestToEnableApprovalsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#listApproverCandidates
 */
export const LIST_APPROVER_CANDIDATES_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_listApproverCandidates';
export const LIST_APPROVER_CANDIDATES_QUERY: RegisteredQuery<
  'result',
  References.ListApproverCandidatesRequestType,
  References.ListApproverCandidatesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_APPROVER_CANDIDATES_QUERY_FIELD_NAME,
  args: ['actorType'],
  fetcher(
    request: References.ListApproverCandidatesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListApproverCandidatesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listApproverCandidatesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getAvailableApprovers
 */
export const GET_AVAILABLE_APPROVERS_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getAvailableApprovers';
export const GET_AVAILABLE_APPROVERS_QUERY: RegisteredQuery<
  'result',
  References.GetAvailableApproversRequestType,
  References.GetAvailableApproversResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AVAILABLE_APPROVERS_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.GetAvailableApproversRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAvailableApproversResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAvailableApproversRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putAvailableApprovers
 */
export const PUT_AVAILABLE_APPROVERS_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putAvailableApprovers';
export const PUT_AVAILABLE_APPROVERS_MUTATION: RegisteredQuery<
  'result',
  References.PutAvailableApproversRequestType,
  References.PutAvailableApproversResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_AVAILABLE_APPROVERS_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'approvers'],
  fetcher(
    request: References.PutAvailableApproversRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutAvailableApproversResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putAvailableApproversRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getAvailableApproversForActorType
 */
export const GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getAvailableApproversForActorType';
export const GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY: RegisteredQuery<
  'result',
  References.GetAvailableApproversForActorTypeRequestType,
  References.GetAvailableApproversForActorTypeResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'actorType'],
  fetcher(
    request: References.GetAvailableApproversForActorTypeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAvailableApproversForActorTypeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAvailableApproversForActorTypeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putAvailableApproversForActorType
 */
export const PUT_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putAvailableApproversForActorType';
export const PUT_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_MUTATION: RegisteredQuery<
  'result',
  References.PutAvailableApproversForActorTypeRequestType,
  References.PutAvailableApproversForActorTypeResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'actorType', 'approvers'],
  fetcher(
    request: References.PutAvailableApproversForActorTypeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutAvailableApproversForActorTypeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putAvailableApproversForActorTypeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalTemplate
 */
export const PUT_APPROVAL_TEMPLATE_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalTemplate';
export const PUT_APPROVAL_TEMPLATE_MUTATION: RegisteredQuery<
  'result',
  References.PutApprovalTemplateRequestType,
  References.PutApprovalTemplateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_APPROVAL_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'approvalTemplate'],
  fetcher(
    request: References.PutApprovalTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutApprovalTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putApprovalTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#deleteApprovalTemplate
 */
export const DELETE_APPROVAL_TEMPLATE_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_deleteApprovalTemplate';
export const DELETE_APPROVAL_TEMPLATE_MUTATION: RegisteredQuery<
  'result',
  References.DeleteApprovalTemplateRequestType,
  References.DeleteApprovalTemplateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_APPROVAL_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.DeleteApprovalTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteApprovalTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.deleteApprovalTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovalDelegates
 */
export const GET_APPROVAL_DELEGATES_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovalDelegates';
export const GET_APPROVAL_DELEGATES_QUERY: RegisteredQuery<
  'result',
  References.GetApprovalDelegatesRequestType,
  References.GetApprovalDelegatesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVAL_DELEGATES_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.GetApprovalDelegatesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovalDelegatesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovalDelegatesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalDelegate
 */
export const PUT_APPROVAL_DELEGATE_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalDelegate';
export const PUT_APPROVAL_DELEGATE_MUTATION: RegisteredQuery<
  'result',
  References.PutApprovalDelegateRequestType,
  References.PutApprovalDelegateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_APPROVAL_DELEGATE_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'owner', 'delegate'],
  fetcher(
    request: References.PutApprovalDelegateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutApprovalDelegateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putApprovalDelegateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#deleteApprovalDelegate
 */
export const DELETE_APPROVAL_DELEGATE_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_deleteApprovalDelegate';
export const DELETE_APPROVAL_DELEGATE_MUTATION: RegisteredQuery<
  'result',
  References.DeleteApprovalDelegateRequestType,
  References.DeleteApprovalDelegateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_APPROVAL_DELEGATE_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'owner'],
  fetcher(
    request: References.DeleteApprovalDelegateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteApprovalDelegateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.deleteApprovalDelegateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovalDelegationOption
 */
export const GET_APPROVAL_DELEGATION_OPTION_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovalDelegationOption';
export const GET_APPROVAL_DELEGATION_OPTION_QUERY: RegisteredQuery<
  'result',
  References.GetApprovalDelegationOptionRequestType,
  References.GetApprovalDelegationOptionResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVAL_DELEGATION_OPTION_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction'],
  fetcher(
    request: References.GetApprovalDelegationOptionRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovalDelegationOptionResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApprovalDelegationOptionRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalDelegationOption
 */
export const PUT_APPROVAL_DELEGATION_OPTION_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalDelegationOption';
export const PUT_APPROVAL_DELEGATION_OPTION_MUTATION: RegisteredQuery<
  'result',
  References.PutApprovalDelegationOptionRequestType,
  References.PutApprovalDelegationOptionResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUT_APPROVAL_DELEGATION_OPTION_MUTATION_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'delegationOption'],
  fetcher(
    request: References.PutApprovalDelegationOptionRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PutApprovalDelegationOptionResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.putApprovalDelegationOptionRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
